<template>
  <div
    class="channel-menu"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div
      class="channel-wrap"
    >
      <div
        class="current-channel"
      >
        <span
          v-for="(item, index) of menu"
          :key="index+'menu'"
          class="menu-item"
          v-show="isActive(item)"
        >
          <span>{{ item.title }}</span>
        </span>
      </div>
      <i class="df-arrow df-arrow_brown" :class="overFlag ? 'df-arrow_active' : ''"></i>
    </div>
    <div
      v-if="overFlag"
      class="channel-item-wrap"
    >
      <ul>
        <li
          v-for="(item, index) of menu"
          :key="index+'channel'"
          class="channel-item"
          @click="toLink(item)"
          @mouseenter="onItemMouseEnter"
          @mouseleave="onItemMouseLeave"
        >
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getCookie } from "../../../utils";
// function isEllipsis(el) {
//   return el.scrollHeight > el.clientHeight;
// }
export default {
  name: "Channels",
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    isActive: {
      type: Function,
      default: () => {
        return () => false;
      },
    },
    color: {
      type: String,
      default: '#2c2d78',
    },
  },
  data() {
    return {
      expend: false,
      isEllipsis: false,
      lang: getCookie('df_lang') || 'zh-CN',
      overFlag: false,
    };
  },
  computed: {
  },
  mounted() {
    // this.refresh()
  },
  methods: {
    // refresh() {
    //   const temp = isEllipsis(this.$refs.container)
    //   if(temp !== this.isEllipsis) {
    //     this.isEllipsis = temp
    //   }
    // }
    onMouseEnter(ev) {
      this.overFlag = true;
    },
    onMouseLeave(ev) {
      this.overFlag = false;
    },
    toLink(item) {
      if (this.isActive(item)) {
        return;
      } else {
        window.location.href = item.url;
      }
    },
    onItemMouseEnter(ev) {
      ev.currentTarget.style.background = this.color;
    },
    onItemMouseLeave(ev) {
      ev.currentTarget.style.background = '#fff';
    },
  },
};
</script>

<style lang="less" scoped>
.channel-menu {
  position: relative;
  .channel-wrap {
    display: flex;
    align-items: center;
    .current-channel {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 33px;
    }
  }
  .channel-item-wrap {
      position: absolute;
      left: 0;
      top: 23px;
      z-index: 9;
      padding-top: 34px;
      ul{
        display:flex;
        flex-wrap: wrap;
        flex-wrap: wrap;
        width: 360px;
        padding: 10px 0;
        background: #FFFFFF;
        border-radius: 2px;
        box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      }
      li{
        flex:  0 0 120px;
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular, PingFang SC,MicrosoftYaHei;
        font-size: 14px;
        &:hover{
          color: #fff;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
}
.menu {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  .wrapper();
  > .container {
    height: 48px;
    overflow: hidden;
    .menu-item {
      padding: 14px 0px;
      margin: 0px 20px;
      word-break: keep-all;
      cursor: pointer;
      -moz-font-smoothing: auto;
      &.active{
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;

        border-bottom: 2px solid #247dff;
        padding-bottom: 12px;
      }
      &:hover {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }
  }
  > .expend {
    flex: 0 0 auto;
    align-self: start;
    padding: 14px 0px;
    margin: 0px 20px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    &:hover {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    > img {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
      transition: transform 100ms ease;
      transform: rotate(180deg);
    }
  }
  &.expended {
    > .container {
      height: auto;
      //overflow: visible;
    }
    > .expend > img {
      transform: rotate(0deg);
    }
  }
}
</style>
